import { OnInit, Component, ContentChildren, ViewChildren, Input, QueryList, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TopoTableColumnComponent } from './topo-table-column.component';

@Component({
    selector: 'topo-columns',
    template: `
    <ng-content></ng-content>
  `,
    standalone: false
})
export class TopoTableColumnsComponent implements OnInit {
  @ContentChildren(TopoTableColumnComponent) columns: QueryList<TopoTableColumnComponent>
  constructor() { }

  ngOnInit(): void {
  }
}
